import { defineMessages } from 'react-intl';

export default defineMessages({
  returnTransfer: {
    id: 'sentinel.components.returnTransferForm.returnTransfer',
    defaultMessage: 'Return Transfer',
  },
  comment: {
    id: 'sentinel.components.returnTransferForm.comment',
    defaultMessage: 'Comment (optional)',
  },
  submit: {
    id: 'sentinel.components.returnTransferForm.submit',
    defaultMessage: 'Confirm Return',
  },
});



// WEBPACK FOOTER //
// ./src/components/ReturnTransferForm/messages.js